import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import template from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/container.pug';
import Panel from '@bingads-webui-campaign-legacy/crud-ad/view/adsPreview/panel';
import ViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsPreview/container';
import config from '@bingads-webui-component-legacy/config/index';
import uuid from '@bingads-webui-component-legacy/uuid/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const {
  IsDisclaimerAdsEnabled,
} = config.get('Permissions') || {};

export default class AdsPreviewContainer extends Backbone.View {
  initialize({
    tabs = [],
  } = {}) {
    this.viewModel = new ViewModel({
      tabs,
    });

    this.tabGroups = _.map(tabs, (tab) => {
      return _.mapObject(tab, (subTab) => {
        return subTab.title;
      });
    });

    if (IsDisclaimerAdsEnabled) {
      this.tab = tabs[0];
    }

    this.panels = _.mapObject(_.extend.apply(this, tabs),
      (tab) => {
        return new Panel({
          template: tab.template,
          viewModel: tab.viewModel,
          title: tab.title,
          i18n: tab.i18n || i18n,
          adType: tab.adType,
        });
      });
  }

  get events() {
    return {
      'click a.preview-tab': 'switchTab',
    };
  }

  render() {
    this.$el.html(template({
      i18n,
      tabGroups: this.tabGroups,
      panels: this.panels,
      uuid,
    }));

    ko.applyBindings(this.viewModel, this.el);

    _.each(this.panels, (panel, name) => {
      this.$(`.preview-${name}`).empty().append(panel.render().el);
    });

    return this;
  }

  switchTab(target) {
    const selected = target.currentTarget.dataset.target;

    this.viewModel.selectedPanel(selected);

    if (IsDisclaimerAdsEnabled) {
      if (this.tab[selected].viewModel.IsDisclaimerPopupHintVisible) {
        this.tab[selected].viewModel.IsDisclaimerPopupHintVisible(false);//eslint-disable-line
      }
    }
  }

  selectedPanel(panel) {
    this.viewModel.selectedPanel(panel);
  }
}
